import React from 'react';
import Slider from 'react-slick';
import Div from '../Div';
import Post from '../Post';
import './upcomingSlider.css'; 

// Post.jsx (cs-style1) already renders exactly what an upcoming-movie card
// needs - poster thumb, a dark gradient overlay, a small "posted by" line,
// and a bold title - so it's reused as-is instead of building a new component.
function formatReleaseDate(dateString) {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString('en-US', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export default function UpcomingSlider({ movies = [] }) {
  if (!movies.length) {
    return <p style={{ color: '#999' }}>No upcoming movies yet.</p>;
  }

  const settings = {
    dots: false,
    arrows: false,
    infinite: movies.length > 3,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1600, settings: { slidesToShow: 3 } },
      { breakpoint: 1200, settings: { slidesToShow: 2 } },
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <Slider {...settings} className="cs-gap-24 cs-upcoming_slider">
      {movies.map((movie) => (
        <Div key={movie._id}>
          <Post
            url="/"
            src={movie.poster}
            alt={movie.title}
            date={formatReleaseDate(movie.releaseDate)}
            title={movie.title}
          />
        </Div>
      ))}
    </Slider>
  );
}
